import React, { Fragment } from "react";
import {
  List,
  Datagrid,
  Filter,
  TextInput,
  TextField,
  EditButton,
  BulkDeleteButton,
  DeleteButton,
  FunctionField,
} from "react-admin";
import { WithdrawPaymentInfonewSelectInput } from "../../UI/Input/SelectInput";
import useCheckPermissions from '../AdminPermissions/useCheckPermissions'

const ListFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="q" alwaysOn />
    <WithdrawPaymentInfonewSelectInput  label="Select Type" source="type" alwaysOn />
  </Filter>
);
const ListActionButtons = ({ ...props }) => {
  return (
    <>
      <BulkDeleteButton
        {...props}
        undoable={false}
        confirmTitle="Delete File Record"
        confirmContent={"Are you sure you want to delete this record?"}
      />
    </>
  );
};

const AgreementAndPaymentList = ({ ...props }) => {
  return (
    <List
      {...props}
      title="Category"
      bulkActionButtons={<ListActionButtons />}
      filters={<ListFilter />}

    >
      <Datagrid rowClick={"show"}>
        <TextField source="id" />
        <TextField source="profile_id" label="Profile Id" />
        <TextField source="type" label="Type" />
       
        {useCheckPermissions('AgreementAndPayment_Edit')?<EditButton />:null}
        {useCheckPermissions('AgreementAndPayment_Delete')?<DeleteButton />:null}
      </Datagrid>
    </List>
  );
};

export default AgreementAndPaymentList;
